// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function CurrencyEthBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m28.18 15.074-11-14a1.5 1.5 0 0 0-2.36 0l-11 14a1.5 1.5 0 0 0 0 1.852l.075.095a.46.46 0 0 0 .055.07l10.875 13.835a1.5 1.5 0 0 0 2.36 0l11-14a1.5 1.5 0 0 0-.005-1.852ZM17.5 6.338l7.14 9.087-7.14 3.25V6.337Zm-3 12.332-7.14-3.25 7.14-9.082V18.67Zm0 3.296v3.697l-4.519-5.75 4.519 2.053Zm3 0 4.519-2.053-4.52 5.75v-3.697Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
